export default {
      id: "Icon--sort-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--sort",
      toString: function () {
        return this.url;
      }
    }